import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'

const InvitationStateCellRenderer = (props) => {
  const { value: status } = props
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div>{lang.clientList.invitationStatus[status]}</div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  statusCircle: {
    display: 'flex',
    minWidth: 10,
    maxWidth: 10,
    minHeight: 10,
    maxHeight: 10,
    borderRadius: '50%',
    marginRight: 20,
  },
  green: {
    background: theme.green,
  },
  blue: {
    background: theme.blue,
  },
  red: {
    background: theme.error,
  },
  orange: {
    background: theme.orange,
  },
  grey: {
    background: theme.greyStateColor,
  },
}))

InvitationStateCellRenderer.propTypes = {
  value: PropTypes.string,
}

export default InvitationStateCellRenderer
